import Request from '@request/Request';
import Model from '@models/Group';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    data = {
      ...Model.data(),
      ...data,
    };
    super(validationObserver, data);
    this.model = new Model();
  }

  async submit() {
    this.beforeSubmit();
    try {
      let response = await this.model.save(this.data());
      $showSuccess(response.message, 'group-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }

  async addMember() {
    this.beforeSubmit();
    try {
      let data = this.data();
      let response = await this.model.addMember(data.id, data.member);
      $showSuccess(
        response.message || 'New member added to group!',
        'group-member-toast'
      );
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }
}
